import React from "react";
import { ChevronDown } from "lucide-react";
import { useLang } from "../lib/i18n";
import FullLogo from "./FullLogo";

export const Hero = ({ onShop, onCorporate }) => {
  const { t } = useLang();
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center justify-center px-6 overflow-hidden"
    >
      {/* Soft gold radial glow — matches the wreath span */}
      <div
        aria-hidden="true"
        className="absolute inset-0 z-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 45% 55% at 50% 50%, rgba(201,169,97,0.18) 0%, rgba(201,169,97,0.06) 55%, transparent 75%)",
        }}
      />

      {/* Top / bottom hairlines */}
      <div className="pointer-events-none absolute inset-x-12 top-12 h-px bg-gradient-to-r from-transparent via-[var(--goldenelia-gold)] to-transparent opacity-60 z-10" />
      <div className="pointer-events-none absolute inset-x-12 bottom-12 h-px bg-gradient-to-r from-transparent via-[var(--goldenelia-gold)] to-transparent opacity-60 z-10" />

      <div className="relative z-10 text-center max-w-6xl mx-auto">
        <div className="reveal reveal-delay-1 flex justify-center mb-12 relative">
          {/* Soft gold pulse aura behind the logo */}
          <div
            aria-hidden="true"
            className="absolute inset-0 -inset-x-12 -inset-y-12 pointer-events-none animate-logo-pulse"
            style={{
              background:
                "radial-gradient(ellipse 60% 55% at 50% 50%, rgba(230,201,138,0.28) 0%, rgba(201,169,97,0.12) 40%, transparent 72%)",
              filter: "blur(8px)",
            }}
          />
          <FullLogo size="min(95vw, 960px)" testid="hero-full-logo" />
        </div>

        <p className="reveal reveal-delay-3 font-serif-luxury italic text-lg sm:text-xl text-[color:var(--goldenelia-cream)]/85 leading-relaxed max-w-xl mx-auto mb-12">
          {t("hero.desc")}
        </p>

        <div className="reveal reveal-delay-4 flex flex-col sm:flex-row items-center justify-center gap-5">
          <button
            data-testid="hero-shop-btn"
            onClick={onShop}
            className="btn-ghost-gold !px-9 !py-4 text-[11px]"
          >
            {t("hero.cta")}
          </button>
          <button
            data-testid="hero-corporate-btn"
            onClick={onCorporate}
            className="font-display text-[10px] tracking-[0.35em] uppercase text-[color:var(--goldenelia-cream)]/75 hover:text-[color:var(--goldenelia-gold)] transition-colors duration-300 underline-offset-8 hover:underline decoration-[color:var(--goldenelia-gold)]/60"
          >
            {t("hero.ctaContact")} →
          </button>
        </div>
      </div>

      <a
        href="#heritage"
        aria-label="scroll"
        className="reveal reveal-delay-4 absolute bottom-8 left-1/2 -translate-x-1/2 z-10 inline-flex flex-col items-center gap-2 text-[color:var(--goldenelia-gold)]/55 hover:text-[color:var(--goldenelia-gold)] transition-colors"
      >
        <span className="font-display text-[9px] tracking-[0.45em]">{t("hero.scroll")}</span>
        <ChevronDown size={16} className="animate-bounce" />
      </a>
    </section>
  );
};

export default Hero;
